// deepa audit logs: technician patient-creation handler
/* eslint-disable */
import { db } from "../../firebase-config";
import { ref as dbRef, push } from "firebase/database"; // deepa audit logs: push helper
import CryptoJS from "crypto-js"; // For encryption/decryption
import { get } from "firebase/database"; // For getting patient data

// Function to check if a string is base64 encoded
const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};



export async function logPatientCreationTech({
  patientIdEncrypted,
  createdBy,
  patientName,
  uploaded3D,
  uploadedReport,
  uploadedDicom,
  modality = "",
  category = "",
  clinicalHistoryEntered = false,
  clinicalHistoryFileAttached = false,
  success,
  failureReason = "",
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Patient_Creation_Technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "New patient added by technician"
        : "Patient creation failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    const entry = {
      event_type: success ? "patient_added_tech" : "patient_creation_failed_tech",
      created_by: createdBy,
      patient_name: patientName,
      ...(success && { patient_id_encrypted: patientIdEncrypted }),
      success,
      timestamp,
      details,
      ...(modality.trim() !== "" && { modality }),
      ...(category.trim() !== "" && { category }),
      ...(uploaded3D && { uploaded_3d: true }),
      ...(uploadedReport && { uploaded_report: true }),
      ...(uploadedDicom && { uploaded_dicom: true }),
      ...(clinicalHistoryEntered && { clinical_history_entered: true }),
      ...(clinicalHistoryFileAttached && { clinical_history_file_attached: true }),
      ...(!success && { failure_reason: failureReason }),
    };
    await push(logRef, entry);
    console.log("Technician patient creation audit log written.");
  } catch (err) {
    console.error("Failed to write technician patient creation audit log:", err);
  }
}

// deepa audit logs: technician bulk assignment handler
export async function logBulkAssignmentTech({
  assignedBy,
  assignedDoctor,
  patientCount,
  patientIds = [],
  patientNames = [],
  success,
  failureReason = "",
  assignmentType = "bulk", // "bulk" or "individual"
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Bulk_Assignment_Technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? `Bulk assignment of ${patientCount} patients to doctor by technician`
        : "Bulk assignment failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    
    // Encrypt all patient IDs
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedPatientIds = patientIds.map(id => 
      CryptoJS.AES.encrypt(id, secretKey).toString()
    );
    
    const entry = {
      event_type: success ? "bulk_assignment_tech" : "bulk_assignment_failed_tech",
      assigned_by: assignedBy,
      assigned_doctor: assignedDoctor,
      patient_count: patientCount,
      assignment_type: assignmentType,
      success,
      timestamp,
      details,
      ...(encryptedPatientIds.length > 0 && { patient_ids_encrypted: encryptedPatientIds }),
      ...(patientNames.length > 0 && { patient_names: patientNames }),
      ...(!success && { failure_reason: failureReason }),
    };
    
    await push(logRef, entry);
    console.log("Technician bulk assignment audit log written.");
  } catch (err) {
    console.error("Failed to write technician bulk assignment audit log:", err);
  }
}

// deepa audit logs: individual doctor assignment handler
export async function logIndividualAssignmentTech({
  assignedBy,
  assignedDoctor,
  patientId,
  patientName,
  success,
  failureReason = "",
  isUnassign = false, // Track if this is an unassignment
  previousDoctors = [], // Track previously assigned doctors
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Report_Finalize_Tec");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? isUnassign 
          ? "Doctor unassigned from patient by technician"
          : "Doctor assigned to patient by technician"
        : "Individual assignment failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = CryptoJS.AES.encrypt(patientId, secretKey).toString();
    
    const entry = {
      event_type: success 
        ? isUnassign ? "doctor_unassigned_tech" : "doctor_assigned_tech"
        : "individual_assignment_failed_tech",
      assigned_by: assignedBy,
      assigned_doctor: assignedDoctor,
      patient_id_encrypted: encryptedId, // Store encrypted ID
      patient_name: patientName,
      success,
      timestamp,
      details,
      ...(previousDoctors.length > 0 && { previous_doctors: previousDoctors }),
      ...(!success && { failure_reason: failureReason }),
    };
    
    await push(logRef, entry);
    console.log("Technician individual assignment audit log written.");
  } catch (err) {
    console.error("Failed to write technician individual assignment audit log:", err);
  }
}

// deepa audit logs: technician clinical history handler - tracks when technicians add/update clinical history
export async function logClinicalHistoryTech({
  technicianName,
  patientId,
  patientName,
  isView = false, // New flag to differentiate view events
  isUpdate = false,
  hasTextEntry,
  hasFileAttachment,
  success,
  failureReason = "",
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Clinical_History_Technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? isUpdate 
          ? "Clinical history updated by technician"
          : "Clinical history added by technician"
        : "Clinical history operation failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID if not already encrypted
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = isBase64(patientId) ? patientId : CryptoJS.AES.encrypt(patientId, secretKey).toString();
    
    const entry = {
      event_type: success
        ? isView
          ? "clinical_history_viewed_tech"
          : isUpdate
          ? "clinical_history_updated_tech"
          : "clinical_history_added_tech"
        : "clinical_history_failed_tech",
      created_by: technicianName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      has_text_entry: hasTextEntry,
      has_file_attachment: hasFileAttachment,
      is_view: isView,
      is_update: isUpdate,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason }),
    };
    
    await push(logRef, entry);
    console.log("Technician clinical history audit log written.");
  } catch (err) {
    console.error("Failed to write technician clinical history audit log:", err);
  }
}

// deepa audit logs: technician data upload handler - tracks when technicians upload patient data
export async function logPatientUploadTech({
  technicianName,
  patientId,
  patientName,
  modality,
  category,
  uploadedDicom,
  uploaded3D,
  uploadedReport,
  success,
  failureReason = "",
}) {
  try {
    // Store under central audit log path so Super-Admin AuditLogs can read it
    const logRef = dbRef(db, "audit_logs/Upload_Event/Technician_Uploads");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "Patient data uploaded by technician"
        : "Patient data upload failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = CryptoJS.AES.encrypt(patientId, secretKey).toString();

    const entry = {
      category: "Upload_Events",
       event_type: success ? "patient_data_upload_tech" : "patient_data_upload_failed_tech",
      uploaded_by: technicianName,
      patient_name: patientName,
      patient_id_encrypted: encryptedId, // Store encrypted ID
      modality,
      category,
      uploaded_dicom: uploadedDicom,
      uploaded_3d: uploaded3D,
      uploaded_report: uploadedReport,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason }),
    };

    await push(logRef, entry);
    console.log("✅ Technician patient data upload audit log written to:", "audit_logs/Upload_Event/Technician_Uploads");
    console.log("📝 Upload log entry:", entry);
  } catch (err) {
    console.error("Failed to write technician patient data upload audit log:", err);
  }
}

// technician audit logs: update existing patient information handler
export async function logPatientInfoUpdateTech({
  technicianName,
  patientId,
  patientName,
  modality,
  category,
  uploadedDicom,
  uploaded3D,
  uploadedReport,
  success,
  failureReason = "",
}) {
  try {
    const logRef = dbRef(db, "audit_logs/Patient_Info_Updates/Technician_Updates");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? "Patient data updated by technician"
        : "Patient data update failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = CryptoJS.AES.encrypt(patientId, secretKey).toString();

    const entry = {
      category: "Patient_Info_Updates",
      event_type: success
        ? "patient_info_update_tech"
        : "patient_info_update_failed_tech",
      updated_by: technicianName,
      patient_name: patientName,
      patient_id_encrypted: encryptedId,
      modality,
      category_label: category,
      uploaded_dicom: uploadedDicom,
      uploaded_3d: uploaded3D,
      uploaded_report: uploadedReport,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason }),
    };

    await push(logRef, entry);
    console.log("✅ Technician patient info update audit log written to:", "audit_logs/Patient_Info_Updates/Technician_Updates");
    console.log("📝 Patient info log entry:", entry);
  } catch (err) {
    console.error("Failed to write technician patient info update audit log:", err);
  }
}

// This function has been deprecated. Use logReportReadTech instead for tracking report read events.

// New function specifically for report read events
export async function logReportReadTech({
  technicianName,
  patientId,
  patientName,
  action, // 'view' or 'download'
  reportUrl,
  success,
  failureReason = "",
}) {
  try {
    // Create the node if it doesn't exist and add the log entry
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/View_Report_Tec");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    
    // Customize action message for read events
    const details = {
      action: success
        ? `Report ${action === 'view' ? 'viewed' : 'downloaded'} by technician ${technicianName}`
        : `Failed to ${action} report by technician ${technicianName}`,
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
      timestamp: new Date().toLocaleString(), // Add readable timestamp in details
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch (error) {
      console.warn("Failed to fetch location info:", error);
    }

    // Encrypt patient ID if not already encrypted
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = isBase64(patientId) ? patientId : CryptoJS.AES.encrypt(patientId, secretKey).toString();

    const entry = {
      event_type: success 
        ? `report_${action}` 
        : `report_${action}_failed`,
      technician_name: technicianName,
      patient_name: patientName,
      patient_id_encrypted: encryptedId,
      report_url: reportUrl,
      read_type: action, // Specific field for read type
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason }),
    };

    // Use push to create a new entry with an auto-generated ID
    const newEntryRef = await push(logRef, entry);
    
    if (!newEntryRef) {
      throw new Error("Failed to create log entry");
    }

    console.log(`Report read event logged successfully: ${action}`);
    return newEntryRef;
  } catch (err) {
    console.error(`Failed to log report read event:`, err);
    throw err; // Re-throw to handle in the calling function
  }
}

// deepa audit logs: Function for logging report download events
export async function logReportDownloadTech({
  technicianName,
  patientId,
  patientName,
  reportUrl,
  success,
  failureReason = "",
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Download_Report_Tec");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    
    const details = {
      action: success
        ? `Report downloaded by technician ${technicianName}`
        : `Failed to download report by technician ${technicianName}`,
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };

    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}

    // Encrypt patient ID if not already encrypted
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = isBase64(patientId) ? patientId : CryptoJS.AES.encrypt(patientId, secretKey).toString();

    const entry = {
      event_type: success ? "report_download" : "report_download_failed",
      technician_name: technicianName,
      patient_name: patientName,
      patient_id_encrypted: encryptedId,
      report_url: reportUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason }),
    };

    await push(logRef, entry);
    console.log("Report download event logged successfully");
  } catch (err) {
    console.error("Failed to log report download event:", err);
  }
}

// deepa audit logs: technician share report handler
export async function logShareEventTech({
  id,
  adminName1,
  selectedLink = "",
  action = "share",
  success = true,
  failureReason = ""
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/share_report_tec");
    const technicianName = localStorage.getItem("Name");
    const currentDate = new Date();
    // Get browser and device info for audit trail
    const browser = navigator.userAgent;
    const device = /Mobi|Android/i.test(browser) ? "Mobile" : "Desktop";
    // Get IP and location info for audit trail
    let ip = "Unknown";
    let location = "Unknown";
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      ip = loc.ip || "Unknown";
      location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch (err) {
      console.warn("Failed to fetch IP info:", err);
    }
    // Get patient details for audit log
    const patientRef = dbRef(db, `superadmin/admins/${adminName1}/patients/${id}`);
    const patientSnapshot = await get(patientRef);
    const patientData = patientSnapshot.val();
    const patientName = patientData?.FullName ? patientData.FullName : "";
    const encryptedPatientId = patientData?.ID || "";
    // Encrypt the report URL for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedReportUrl = selectedLink
      ? CryptoJS.AES.encrypt(selectedLink, secretKey).toString()
      : "";
    // Create audit log entry with required schema
    const logEntry = {
      event_type: `report_share_${action}`,
      technician_name: technicianName,
      patient_id_encrypted: encryptedPatientId,
      patient_name: patientName,
      report_url: encryptedReportUrl,
      success,
      timestamp: currentDate.toISOString(),
      details: {
        action,
        browser,
        device,
        ip,
        location
      },
      ...(!success && { failure_reason: failureReason })
    };
    await push(logRef, logEntry);
    console.log("Share event logged successfully");
  } catch (error) {
    console.error("Failed to log share event:", error);
  }
}

// deepa audit logs: Function to log DICOM view events by technician
export async function logViewDicomTechnician({
  technicianName,
  patientId,
  patientName,
  dicomUrl,
  success,
  failureReason = ""
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/patientdicomview_technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "DICOM viewed by technician" : "DICOM view failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    // Encrypt patient ID and DICOM URL for audit log
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    const encryptedDicomUrl = dicomUrl
      ? CryptoJS.AES.encrypt(dicomUrl, secretKey).toString()
      : "";
    // Create audit log entry
    const entry = {
      event_type: success ? "patientdicomview_technician" : "patientdicomview_failed_technician",
      technician_name: technicianName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      dicom_url: encryptedDicomUrl,
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };
    await push(logRef, entry);
    console.log("Technician DICOM view event logged successfully");
  } catch (err) {
    console.error("Failed to write technician DICOM view audit log:", err);
  }
}

// deepa audit logs: Function to log prescription view events by technician
export async function logViewPrescriptionTechnician({
  technicianName,
  patientId,
  patientName,
  prescriptionUrl,
  success,
  failureReason = ""
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/prescription_view_technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "Prescription viewed by technician" : "Prescription view failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    //deepaaudit logs: Encrypt patient ID and prescription URL for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    const encryptedPrescriptionUrl = prescriptionUrl
      ? CryptoJS.AES.encrypt(prescriptionUrl, secretKey).toString()
      : "";
    // Create audit log entry
    const entry = {
      event_type: success ? "prescription_view_technician" : "prescription_view_failed_technician",
      technician_name: technicianName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      prescription_url: encryptedPrescriptionUrl, //deepaaudit logs: encrypted for HIPAA
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };
    await push(logRef, entry);
    console.log("Technician prescription view event logged successfully");
  } catch (err) {
    console.error("Failed to write technician prescription view audit log:", err);
  }
}

//deepaaudit logs: Function to log AI model run events by technician
export async function logAIModelRunTechnician({
  technicianName,
  patientId,
  patientName,
  modelId,
  modelDisplayName,
  subModelId = null,
  success,
  failureReason = ""
}) {
  console.log("logAIModelRunTechnician called with", {
    technicianName,
    patientId,
    patientName,
    modelId,
    modelDisplayName,
    subModelId,
    success,
    failureReason
  });
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/ai_model_run_technician");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success ? "AI model run by technician" : "AI model run failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown"
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    //deepaaudit logs: Encrypt patient ID for HIPAA compliance
    const secretKey = process.env.REACT_APP_SECRET_KEY || "default_key";
    const encryptedId = patientId 
      ? CryptoJS.AES.encrypt(patientId.toString(), secretKey).toString()
      : "Unknown";
    // Create audit log entry
    const entry = {
      event_type: success ? "ai_model_run_technician" : "ai_model_run_failed_technician",
      technician_name: technicianName,
      patient_id_encrypted: encryptedId,
      patient_name: patientName,
      model_id: modelId,
      model_display_name: modelDisplayName,
      ...(subModelId && { sub_model_id: subModelId }),
      success,
      timestamp,
      details,
      ...(!success && { failure_reason: failureReason })
    };
    await push(logRef, entry);
    console.log("Technician AI model run event logged successfully");
  } catch (err) {
    console.error("Failed to write technician AI model run audit log:", err);
  }
}

// deepa audit logs: individual doctor assignment handler for Report Read column
export async function logReportReadAssignmentTech({
  assignedBy,
  assignedDoctor,
  patientId,
  patientName,
  success,
  failureReason = "",
  isUnassign = false, // Track if this is an unassignment
  previousDoctors = [], // Track previously assigned doctors
}) {
  try {
    const logRef = dbRef(db, "audit_logs/UserManagement/Technician_logs/Report_Read_Tec");
    const timestamp = new Date().toISOString();
    const userAgent = navigator.userAgent;
    const deviceType = /Mobi|Android/i.test(userAgent) ? "Mobile" : "Desktop";
    const details = {
      action: success
        ? isUnassign 
          ? "Doctor unassigned from patient (Report Read) by technician"
          : "Doctor assigned to patient (Report Read) by technician"
        : "Report Read assignment failed by technician",
      ip: "Unknown",
      browser: userAgent,
      device: deviceType,
      location: "Unknown",
    };
    try {
      const resp = await fetch("https://ipapi.co/json/");
      const loc = await resp.json();
      details.ip = loc.ip || "Unknown";
      details.location = `${loc.city || "Unknown"}, ${loc.country_name || "Unknown"}`;
    } catch {}
    // Encrypt patient ID
    const secretKey = process.env.REACT_APP_SECRET_KEY;
    const encryptedId = CryptoJS.AES.encrypt(patientId, secretKey).toString();
    const entry = {
      event_type: success 
        ? isUnassign ? "doctor_unassigned_report_read_tech" : "doctor_assigned_report_read_tech"
        : "report_read_assignment_failed_tech",
      assigned_by: assignedBy,
      assigned_doctor: assignedDoctor,
      patient_id_encrypted: encryptedId, // Store encrypted ID
      patient_name: patientName,
      success,
      timestamp,
      details,
      ...(previousDoctors.length > 0 && { previous_doctors: previousDoctors }),
      ...(!success && { failure_reason: failureReason }),
    };
    await push(logRef, entry);
    console.log("Technician Report Read assignment audit log written.");
  } catch (err) {
    console.error("Failed to write technician Report Read assignment audit log:", err);
  }
}
